import { createIcon } from '../createIcon.tsx';

export const BathIcon = createIcon(
	'BathIcon',
	<>
		<path d="M9 6 6.5 3.5a1.5 1.5 0 0 0-2.5 1.5" />
		<path d="M3 12V5" />
		<path d="M3 12h18v3a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z" />
		<line x1="6" y1="20" x2="6" y2="22" />
		<line x1="18" y1="20" x2="18" y2="22" />
	</>,
);
